/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react'
import { useForm, useFieldArray, Controller } from 'react-hook-form'
import _ from 'lodash'
import BackButton from 'components/Button/BackButton'
import { Box, Button } from '@chakra-ui/react'
import { useSelector, useDispatch } from 'react-redux'
import SpinnerLoading from 'components/Loading/SpinnerLoading'
import { useTranslation } from 'react-i18next'
import 'katex/dist/katex.min.css'
import { useParams, useHistory } from 'react-router-dom'
import * as actions from '../../../../redux/actions'
import DisplayAddGroup from './DisplayAddGroup'

export default function GroupEdit() {
  const { t, i18n } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [select, setSelect] = useState('GAUGE')
  const params = useParams()
  const station = useSelector((state) => state.station)
  const dispatch = useDispatch()
  const history = useHistory()
  const [isFetchNewOne, setisFetchNewOne] = useState(true)
  const [selectGauge, setSelectGauge] = useState([])
  const [selectChart, setSelectChart] = useState([])
  const [selectDiagram, setSelectDiagram] = useState([])
  const [group, setGroup] = useState()
  const { register, handleSubmit, reset, control, setValue } = useForm()

  useEffect(() => {
    dispatch(actions.stationGet(params.stationId)).then(() => {
      setisFetchNewOne(false)
      setIsLoading(true)
    })

    return () => {}
  }, [params?.stationId])

  useEffect(() => {
    _.map(station?.groups, (group) => {
      if (group._id === params.groupId) {
        setSelectGauge(group.gauge)
        setSelectChart(group.chart)
        setSelectDiagram(group.diagram)
        setGroup(group)
        setValue('groupName', group.groupName)
        setValue('description', group.description)
        setValue('role', group.role)
      }
    })

    return () => {}
  }, [station])

  useEffect(() => {
    setisFetchNewOne(false)
    return () => {}
  }, [select, isFetchNewOne])
  // console.log('station', selectGauge, selectGaugeNew)

  const onSubmit = async (data, e) => {
    const payload = {
      groupName:
        data?.groupName === '' || data?.groupName === undefined
          ? group?.groupName
          : data?.groupName,
      description:
        data?.description === '' || data?.description === undefined
          ? group?.description
          : data?.description,
      role: data?.role === group?.role ? group?.role : data?.role,
      gauge: selectGauge,
      chart: selectChart,
      diagram: selectDiagram,
    }

    //console.log('Data', data, payload)
    let confirm = window.confirm('ยืนยันการแก้ไขกลุ่ม')
    if (confirm) {
      e.preventDefault()
      let templateValue = station
      const selectedGroup = _.find(
        station.groups,
        (gr) => gr._id === params.groupId
      )
      const selectedGroupIndex = _.findIndex(
        station.groups,
        (gr) => gr._id === params.groupId
      )
      const mergedGroupData = _.merge(selectedGroup, payload)

      templateValue.groups[selectedGroupIndex] = mergedGroupData

      //console.log('New Added Value ', mergedGroupData, templateValue)
      dispatch(actions.stationPut(params.stationId, templateValue)).then(() => {
        dispatch(actions.stationAll())
        history.goBack()
      })
    }
  }

  const handleEditAttr = (data) => {
    // console.log('data', data)
    const checkGauge = _.find(selectGauge, (e) => e === data?._id)
    const checkChart = _.find(selectChart, (e) => e === data?._id)
    const checkDiagram = _.find(selectDiagram, (e) => e === data?._id)
    const arrayGauge = selectGauge
    const arrayChart = selectChart
    const arrayDiagram = selectDiagram

    if (select === 'GAUGE') {
      if (!_.isEmpty(checkGauge)) {
        _.remove(arrayGauge, (e) => e === data?._id)
      } else {
        arrayGauge.push(data?._id)
      }
    } else if (select === 'CHART') {
      if (!_.isEmpty(checkChart)) {
        _.remove(arrayChart, (e) => e === data?._id)
      } else {
        arrayChart.push(data?._id)
      }
    } else if (select === 'DIAGRAM') {
      if (!_.isEmpty(checkDiagram)) {
        _.remove(arrayDiagram, (e) => e === data?._id)
      } else {
        arrayDiagram.push(data?._id)
      }
    }

    // console.log('templateValue', group, data, selectGauge)
    setSelectGauge(arrayGauge)
    setSelectChart(arrayChart)
    setSelectDiagram(arrayDiagram)
    setisFetchNewOne(true)
  }

  if (station && isLoading) {
    return (
      <div>
        <div className="relative  min-w-0 break-words bg-gray-100 w-full mb-6 shadow-lg rounded">
          <div className=" rounded-t mb-0 px-4 py-3 bg-transparent">
            <div className="flex flex-wrap items-center">
              <div className="relative w-full max-w-full flex-grow flex-1">
                <h6 className="uppercase text-gray-500 mb-1 text-xs font-semibold font-sans">
                  {t('setting.systemManagement')}
                </h6>
                <h6 className="text-gray-800 text-2xl font-bold font-sans">
                  {'เพิ่มกลุ่มลงในสถานี\n'}
                  {station.name}
                </h6>
              </div>
            </div>
            <Button>
              <BackButton />
            </Button>

            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="grid sm:grid-cols-1 lg:grid-cols-5 px-4 lg:px-10 py-8 pt-0 my-5">
                <div className="w-full px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-sm font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      {'ชื่อกลุ่ม'}
                    </label>

                    <input
                      name="groupName"
                      type="text"
                      defaultValue={group?.groupName}
                      required
                      {...register('groupName')}
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder={t('เช่น group 1 ')}
                    />
                  </div>
                </div>
                <div className="w-full px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-sm font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      {'เกี่ยวกับกลุ่ม'}
                    </label>
                    <input
                      name="description"
                      type="text"
                      defaultValue={group?.description}
                      {...register('description')}
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder={t('เช่น group 1 ')}
                    />
                  </div>
                </div>
                <div className="w-full  px-4">
                  <div className="relative w-full  mb-3">
                    <label
                      className="block uppercase text-gray-700 text-ms font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      สิทธิการเข้าถึง
                    </label>

                    <select
                      name="role"
                      defaultValue={group?.role}
                      {...register('role')}
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                    >
                      <option value={'USER'}>พนักงานทั่วไป ขึ้นไป</option>
                      <option value={'ADMIN'}>
                        พนักงานระดับหัวหน้า ขึ้นไป
                      </option>
                      <option value={'MANAGER'}>ผู้บริหาร</option>
                      <option value={'SUPERUSER'}>ผู้ดูแลระบบ</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-3 text">
                  <div
                    className={`grid ${
                      select === 'GAUGE' ? 'bg-gray-500' : 'bg-white'
                    } shadow rounded py-4 transition-transform transform text-center hover:scale-105`}
                    onClick={(event) => {
                      setSelect('GAUGE')
                    }}
                  >
                    <i className="fa fa-solid fa-plus text-gray-800 text-center "></i>
                    <p className=" text-gray-800 mb-0 text-center font-bold ">
                      เกจ
                    </p>
                  </div>

                  <div
                    className={`grid ${
                      select === 'CHART' ? 'bg-gray-500' : 'bg-white'
                    } shadow rounded py-4 transition-transform transform text-center hover:scale-105`}
                    onClick={(event) => {
                      setSelect('CHART')
                    }}
                  >
                    <i className="fa fa-solid fa-plus text-gray-800 text-center "></i>
                    <p className=" text-gray-800 mb-0 text-center font-bold ">
                      กราฟ
                    </p>
                  </div>

                  <div
                    className={`grid ${
                      select === 'DIAGRAM' ? 'bg-gray-500' : 'bg-white'
                    } shadow rounded py-4 transition-transform transform text-center hover:scale-105`}
                    onClick={(event) => {
                      setSelect('DIAGRAM')
                    }}
                  >
                    <i className="fa fa-solid fa-plus text-gray-800 text-center "></i>
                    <p className=" text-gray-800 mb-0 text-center font-bold ">
                      ไดอะแกรม
                    </p>
                  </div>
                </div>

                <div className="text-center px-4 gap-0 py-3 ">
                  <Button
                    isFullWidth
                    colorScheme="blue"
                    variant="solid"
                    type="submit"
                  >
                    {t('utility.save')}{' '}
                  </Button>
                </div>
              </div>
              <DisplayAddGroup
                select={select}
                station={station}
                handleEditAttr={handleEditAttr}
                selectGauge={selectGauge}
                selectChart={selectChart}
                selectDiagram={selectDiagram}
              />
            </form>
          </div>
        </div>
      </div>
    )
  } else {
    return <SpinnerLoading />
  }
}
